import React from 'react';
import clsx from 'clsx';
import { Divider, Grid } from '@mui/material';

import { Icon, Text, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

export interface StatType {
	classes?: {
		name?: string;
		percent?: string;
		value?: string;
	};
	name: string;
	value?: number;
	percent?: number;
	color?: string;
}

interface DetailsSectionStatsProps {
	title: React.ReactNode;
	subheader?: React.ReactNode;
	headerAction?: React.ReactNode;
	stats: StatType[][];
}

export default function DetailsSectionStats({ title, subheader, headerAction, stats }: DetailsSectionStatsProps) {
	return (
		<DetailsSectionWrapper
			avatar={<Icon icon="chart-bar" />}
			title={title}
			subheader={subheader}
			headerAction={headerAction}
		>
			<Grid container justifyContent="space-between" alignItems="center" spacing={1}>
				{stats.map((group, groupIndex) => (
					<React.Fragment key={groupIndex}>
						{groupIndex !== 0 && (
							<Grid size={12}>
								<Divider />
							</Grid>
						)}
						{group.map((stat, statIndex) => (
							<React.Fragment key={statIndex}>
								<Grid size={6}>
									<Text className={stat.classes?.name}>{stat.name}</Text>
								</Grid>
								<Grid size={2}>
									<Text
										className={clsx('tabular-nums', stat.classes?.percent)}
										align="right"
										sx={{ color: stat.color, fontWeight: stat.color ? 600 : 400 }}
									>
										{stat.percent !== undefined ? Utils.formatPercentage(stat.percent * 100) : ''}
									</Text>
								</Grid>
								<Grid size={4}>
									<Text
										className={clsx('tabular-nums', stat.classes?.value)}
										align="right"
										sx={{ color: stat.color, fontWeight: stat.color ? 600 : 400 }}
									>
										{Utils.formatCurrency(stat.value)}
									</Text>
								</Grid>
							</React.Fragment>
						))}
					</React.Fragment>
				))}
			</Grid>
		</DetailsSectionWrapper>
	);
}
